import { useContext } from 'react';
import { LanguageContext } from '../contextApi/LanguageContext';

export default function useLanguage() {
	return useContext(LanguageContext);
}
